module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-piso-389d91a3a0e22c02442ae7b2c3a50660.jpg";